<script setup lang="ts"></script>

<template>
	<ul class="steps w-full pt-6">
		<slot />
	</ul>
</template>
